export const COOKIE_HOST = process.env.VUE_APP_COOKIE_HOST;
export const IS_DEV = process.env.NODE_ENV === "development";
export const AUTH_URL = process.env.VUE_APP_AUTH_URL;

export const API_URL = process.env.VUE_APP_API_URL;
export const AUTH_LOGOUT_URL = process.env.VUE_APP_AUTH_LOGOUT_URL;
export const RESOURCE_URL = process.env.VUE_APP_IMG_URL;
export const NEWRESOURCE_URL = process.env.VUE_APP_NEWIMG_URL;

export const MARKET_URL = process.env.VUE_APP_MARKET_URL;
export const CABINET_URL = process.env.VUE_APP_CABINET_URL;
export const RKP_URL = process.env.VUE_APP_RKP_URL;
export const DWM_URL = process.env.VUE_APP_DWM_URL;
export const DTM_URL = process.env.VUE_APP_DTM_URL;
export const HOME_URL = process.env.VUE_APP_HOME_URL;

export const FINDOC_URL = process.env.VUE_APP_FINDOC_URL;
export const BA_URL = process.env.VUE_APP_BA_URL;
export const INFO_URL = process.env.VUE_APP_INFO_URL;
export const DT_POS_URL = process.env.VUE_APP_DT_POS_URL;
export const MODE = process.env.VUE_APP_MODE;
export const DECRYPT_KEY = process.env.VUE_APP_DECRYPT_KEY;
